import React from 'react'
import { useParams, Navigate } from 'react-router-dom'

import { isNullable } from '@app/utils'

import { ERROR_PAGE } from '@app/constants/page'

import { innerPageType } from './constans'

import type { InnerPageLayoutProps } from './types'

export const InnerPageLayout: React.FC<InnerPageLayoutProps> = ({ type, render }: InnerPageLayoutProps) => {
  const { id } = useParams()

  if (isNullable(id)) {
    return (
      <Navigate
        to={ ERROR_PAGE }
        replace
      />
    )
  }

  switch (type) {
    case innerPageType.STRING:
      return render(id)
    case innerPageType.NUMBER: {
      const parsedId = parseInt(id)

      if (isNaN(parsedId)) {
        return (
          <Navigate
            to={ ERROR_PAGE }
            replace
          />
        )
      }

      return render(parsedId)
    }
  }
}
